import React, { PropsWithChildren } from "react"

import { useCustomerInfo } from "../../CustomerInfo"

export const WithLoginPageFallback = ({ children }: PropsWithChildren) => {
	const customerInfo = useCustomerInfo()

	const customerInfoIsReady = !!customerInfo.data

	// TODO: Add the fallback component (if needed)
	return <>{customerInfoIsReady ? children : null}</>
}
